const projects = {
  en: {
    'projects.title': 'Projects',
    'projects.subtitle': 'Manage your projects and track progress',
    'projects.newProject': 'New Project',
    'projects.searchPlaceholder': 'Search projects...',
    'projects.allStatuses': 'All Statuses',
    'projects.allPriorities': 'All Priorities',
    'projects.allClients': 'All Clients',
    'projects.includeArchived': 'Include archived',
    'projects.archived': 'Archived',
    'projects.fixedPrice': 'Fixed Price',
    'projects.rate': 'Rate',
    'projects.perHour': '/hr',
    'projects.due': 'Due',
    'projects.created': 'Created',
    'projects.progress': 'Progress',
    'projects.logged': 'logged',
    'projects.assignedTo': 'Assigned To',
    'projects.assigneesHint': 'Select one or more team members',
    'projects.assignedToMore': '{count} more',
    'projects.unassigned': 'Unassigned',
    'projects.noUsers': 'No users available',
    'projects.emptyEmployee': 'No projects are assigned to you yet.',
    'projects.empty.title': 'No projects found',
    'projects.empty.subtitle': 'Get started by creating your first project.',
    'projects.createProject': 'Create Project',
    'projects.cancel': 'Cancel',
    'projects.updateProject': 'Update Project',

    'projects.form.name': 'Project Name',
    'projects.form.client': 'Client',
    'projects.form.selectClient': 'Select a client',
    'projects.form.description': 'Description',
    'projects.form.status': 'Status',
    'projects.form.priority': 'Priority',
    'projects.form.fixedPrice': 'Fixed Price',
    'projects.form.hourlyRate': 'Hourly Rate',
    'projects.form.deadline': 'Deadline',
    'projects.form.dueDate': 'Due Date',

    'projects.validation.nameRequired': 'Project name is required',
    'projects.validation.clientRequired': 'Client is required',

    'projects.modal.createTitle': 'Create New Project',
    'projects.modal.editTitle': 'Edit Project',

    'projects.toast.created': 'Project created successfully',
    'projects.toast.createFailed': 'Failed to create project',
    'projects.toast.updated': 'Project updated successfully',
    'projects.toast.updateFailed': 'Failed to update project',
    'projects.toast.deleted': 'Project deleted successfully',
    'projects.toast.deleteFailed': 'Failed to delete project',
    'projects.error.load': 'Failed to load projects',
    'projects.confirm.deleteProject': 'Are you sure you want to delete this project? This action cannot be undone.',

    'projects.detail.title': 'Project Details',
    'projects.detail.error.load': 'Failed to load project details',
    'projects.detail.startTimer': 'Start Timer',
    'projects.detail.totalHours': 'Total Hours',
    'projects.detail.totalCost': 'Total Cost',
    'projects.detail.tasks': 'Tasks',
    'projects.detail.deadline': 'Deadline',
    'projects.detail.none': 'None',
    'projects.detail.overview': 'Overview',
    'projects.detail.timeEntries': 'Time Entries',
    'projects.detail.budget': 'Budget',
    'projects.detail.noDescription': 'No description provided',
    'projects.detail.notSet': 'Not set',
    'projects.detail.budgetProgress': 'Budget Progress',
    'projects.detail.spent': 'spent',
    'projects.detail.budgetLabel': 'budget',

    'projects.task.add': 'Add Task',
    'projects.task.editTitle': 'Edit Task',
    'projects.task.update': 'Update Task',
    'projects.task.title': 'Task Title',
    'projects.task.titleRequired': 'Task title is required',
    'projects.task.empty': 'No tasks yet',
    'projects.task.confirm.delete': 'Are you sure you want to delete this task?',
    'projects.task.toast.added': 'Task added successfully',
    'projects.task.toast.addFailed': 'Failed to add task',
    'projects.task.toast.updated': 'Task updated successfully',
    'projects.task.toast.updateFailed': 'Failed to update task',
    'projects.task.toast.deleted': 'Task deleted successfully',
    'projects.task.toast.deleteFailed': 'Failed to delete task',

    'projects.timer.started': 'Timer started successfully',
    'projects.timer.startFailed': 'Failed to start timer',
    'projects.workingOn': 'Working on',

    'projects.time.empty': 'No time entries yet',
    'projects.table.date': 'Date',
    'projects.table.task': 'Task',
    'projects.table.duration': 'Duration',
    'projects.table.user': 'User',

    'projects.priority.low': 'Low',
    'projects.priority.medium': 'Medium',
    'projects.priority.high': 'High',
    'projects.priority.urgent': 'Urgent',
  },

  es: {
    'projects.title': 'Proyectos',
    'projects.subtitle': 'Administra tus proyectos y sigue el progreso',
    'projects.newProject': 'Nuevo proyecto',
    'projects.searchPlaceholder': 'Buscar proyectos...',
    'projects.allStatuses': 'Todos los estados',
    'projects.allPriorities': 'Todas las prioridades',
    'projects.allClients': 'Todos los clientes',
    'projects.includeArchived': 'Incluir archivados',
    'projects.archived': 'Archivado',
    'projects.fixedPrice': 'Precio fijo',
    'projects.rate': 'Tarifa',
    'projects.perHour': '/h',
    'projects.due': 'Vence',
    'projects.created': 'Creado',
    'projects.progress': 'Progreso',
    'projects.logged': 'registradas',
    'projects.assignedTo': 'Asignado a',
    'projects.assigneesHint': 'Selecciona uno o más miembros del equipo',
    'projects.assignedToMore': '{count} más',
    'projects.unassigned': 'Sin asignar',
    'projects.noUsers': 'No hay usuarios disponibles',
    'projects.emptyEmployee': 'Aún no tienes proyectos asignados.',
    'projects.empty.title': 'No se encontraron proyectos',
    'projects.empty.subtitle': 'Comienza creando tu primer proyecto.',
    'projects.createProject': 'Crear proyecto',
    'projects.cancel': 'Cancelar',
    'projects.updateProject': 'Actualizar proyecto',

    'projects.form.name': 'Nombre del proyecto',
    'projects.form.client': 'Cliente',
    'projects.form.selectClient': 'Selecciona un cliente',
    'projects.form.description': 'Descripción',
    'projects.form.status': 'Estado',
    'projects.form.priority': 'Prioridad',
    'projects.form.fixedPrice': 'Precio fijo',
    'projects.form.hourlyRate': 'Tarifa por hora',
    'projects.form.deadline': 'Fecha límite',
    'projects.form.dueDate': 'Fecha de vencimiento',

    'projects.validation.nameRequired': 'El nombre del proyecto es obligatorio',
    'projects.validation.clientRequired': 'El cliente es obligatorio',

    'projects.modal.createTitle': 'Crear nuevo proyecto',
    'projects.modal.editTitle': 'Editar proyecto',

    'projects.toast.created': 'Proyecto creado correctamente',
    'projects.toast.createFailed': 'No se pudo crear el proyecto',
    'projects.toast.updated': 'Proyecto actualizado correctamente',
    'projects.toast.updateFailed': 'No se pudo actualizar el proyecto',
    'projects.toast.deleted': 'Proyecto eliminado correctamente',
    'projects.toast.deleteFailed': 'No se pudo eliminar el proyecto',
    'projects.error.load': 'No se pudieron cargar los proyectos',
    'projects.confirm.deleteProject': '¿Seguro que quieres eliminar este proyecto? Esta acción no se puede deshacer.',

    'projects.detail.title': 'Detalles del proyecto',
    'projects.detail.error.load': 'No se pudieron cargar los detalles del proyecto',
    'projects.detail.startTimer': 'Iniciar temporizador',
    'projects.detail.totalHours': 'Horas totales',
    'projects.detail.totalCost': 'Costo total',
    'projects.detail.tasks': 'Tareas',
    'projects.detail.deadline': 'Fecha límite',
    'projects.detail.none': 'Ninguna',
    'projects.detail.overview': 'Resumen',
    'projects.detail.timeEntries': 'Entradas de tiempo',
    'projects.detail.budget': 'Presupuesto',
    'projects.detail.noDescription': 'No se proporcionó una descripción',
    'projects.detail.notSet': 'No definido',
    'projects.detail.budgetProgress': 'Progreso del presupuesto',
    'projects.detail.spent': 'gastado',
    'projects.detail.budgetLabel': 'presupuesto',

    'projects.task.add': 'Agregar tarea',
    'projects.task.editTitle': 'Editar tarea',
    'projects.task.update': 'Actualizar tarea',
    'projects.task.title': 'Título de la tarea',
    'projects.task.titleRequired': 'El título de la tarea es obligatorio',
    'projects.task.empty': 'Sin tareas todavía',
    'projects.task.confirm.delete': '¿Seguro que quieres eliminar esta tarea?',
    'projects.task.toast.added': 'Tarea agregada correctamente',
    'projects.task.toast.addFailed': 'No se pudo agregar la tarea',
    'projects.task.toast.updated': 'Tarea actualizada correctamente',
    'projects.task.toast.updateFailed': 'No se pudo actualizar la tarea',
    'projects.task.toast.deleted': 'Tarea eliminada correctamente',
    'projects.task.toast.deleteFailed': 'No se pudo eliminar la tarea',

    'projects.timer.started': 'Temporizador iniciado correctamente',
    'projects.timer.startFailed': 'No se pudo iniciar el temporizador',
    'projects.workingOn': 'Trabajando en',

    'projects.time.empty': 'Sin entradas de tiempo todavía',
    'projects.table.date': 'Fecha',
    'projects.table.task': 'Tarea',
    'projects.table.duration': 'Duración',
    'projects.table.user': 'Usuario',

    'projects.priority.low': 'Baja',
    'projects.priority.medium': 'Media',
    'projects.priority.high': 'Alta',
    'projects.priority.urgent': 'Urgente',
  },
};

export default projects;
